import { useReducer, useCallback } from 'react'

import { bidReducer, BID_ACTIONS, initialState } from './bidReducer'

export function usePrice() {
  const [{ biddingPrice, biddingPriceError }, bidDispatch] = useReducer(bidReducer, initialState)

  function decreasePrice() {
    bidDispatch({ type: BID_ACTIONS.DECREMENT_BID_PRICE })
  }

  function increasePrice() {
    bidDispatch({ type: BID_ACTIONS.INCREMENT_BID_PRICE })
  }

  const setPrice = useCallback(price => {
    bidDispatch({ type: BID_ACTIONS.SET_BIDDING_PRICE, payload: price })
  }, [])

  return {
    biddingPrice,
    biddingPriceError,
    decreasePrice,
    increasePrice,
    setPrice,
  }
}
